import numeral from "numeral"
import type { Fraction } from "../math"

export function formatCrypto(value: number | string | Fraction) {
  const numeralValue = numeral(
    typeof value === "number" || typeof value === "string"
      ? value
      : value.toFixed(18),
  )
  const normalizedValue = numeralValue.value() ?? 0
  if (normalizedValue === 0) return "0"

  if (normalizedValue < 0.000001) return "<0.000001"
  else if (normalizedValue < 10) return numeralValue.format("0.[000000]")
  else if (normalizedValue < 1000000) return numeralValue.format("0,00.[00]")
  else return numeralValue.format("0.[00]a").toUpperCase()
}

export function formatPricesCrypto(
  value: Fraction,
  decimals: number | bigint,
  isOracle = true,
) {
  const numeralValue = numeral(
    typeof value === "number" ? value : value.toFixed(Number(decimals)),
  )
  const normalizedValue = numeralValue.value() ?? 0
  if (normalizedValue === 0) return "0"

  if (normalizedValue < 0.000001) return "<0.000001"
  if (isOracle) {
    if (normalizedValue < 10) return numeralValue.format("0.[000000]")
    else if (normalizedValue < 100) return numeralValue.format("0.[00000]")
    else if (normalizedValue < 1000) return numeralValue.format("0.[0000]")
    else return numeralValue.format("0,0").toUpperCase()
  }

  return numeralValue.format("0.00a").toUpperCase()
}
